export const formatDuration = (minutes: number) => {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return `${hours > 0 ? `${hours}ч ` : ''}${mins > 0 ? `${mins}м`: ''}`;
};